import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import FileUpload from "../../../Components/common/FileUpload/FileUpload";
import FileCardButton from "../../../Components/UI/FileCardButton/FileCardButton";
import Backdrop from "../../../Components/UI/Backdrop/Backdrop";

import WebIcon from "../../../Components/Icon-SVG/WebIcon";

import { addNotification } from "../../../store/actions/notifierActions";
import { RequestThreatHunterSubmit } from "../../../store/actions/integrationsActions";

const SubmitCard = () => {
  const dispatch = useDispatch();

  const loading = useSelector((state) => state.integrations.threatHunterSubmitLoading);

  const [file, setFile] = useState(null);

  const onFileError = (errMessage) => {
    if (!errMessage) return;
    dispatch(
      addNotification({
        message: errMessage,
        options: { variant: "error" },
      }),
    );
  };

  const onFileSelected = (selectedFile) => {
    setFile(selectedFile);
  };

  const submitHandler = () => {
    if (!file) {
      dispatch(
        addNotification({
          message: "Please select a .tonz file.",
          options: { variant: "error" },
        }),
      );
    }
    dispatch(RequestThreatHunterSubmit({ file, onSuccess: () => setFile(null) }));
  };

  return (
    <div className="hunterbox__submit-card border">
      <div className="hunterbox__submit-card__wrapper">
        <p>Submit TONZ/JSON finding file to get threat hunting report:</p>
        <FileUpload
          file={file}
          setFile={onFileSelected}
          setFileError={onFileError}
          allowedExtensions={["tonz", "json"]}
          errorMessage={`Please select a .tonz or .json file.`}
          styles={{ formWidth: "100%", infoTextWidth: "130px", infoTextPadding: "0" }}
        />
        <FileCardButton onClick={submitHandler}>
          <WebIcon width={21} height={21} color="white" />
          <p>Submit</p>
        </FileCardButton>
      </div>
      <Backdrop show={loading} message={`Submitting file, please wait...`} />
    </div>
  );
};

export default SubmitCard;
